const DATA_LIST_HOTEL_UPDATED = (state, dataListHotel) => {
  state.dataListHotel = dataListHotel
}

const SERVICES_UPDATED = (state, services) => {
  state.services = services
}

export default {
  DATA_LIST_HOTEL_UPDATED,
  SERVICES_UPDATED
}
